import React from "react";
import { cn, DataObserveKey, Icon, IconChevron } from "@siteimprove/fancylib";
import * as scss from "./table-expander.scss";

export function TableExpander(
	props: {
		/** Content of the table cell */
		children: React.ReactNode;
		/** Is the cell expanded? */
		expanded: boolean;
		/** Which element does it expand? */
		controls: string;
		/** Callback for onClick event */
		onClick: (e: React.MouseEvent) => void;
		/** Alignment of the cell content and expander */
		align: "left" | "center" | "right";
	} & DataObserveKey
): JSX.Element {
	const { children, expanded, controls, onClick, align } = props;

	const chevy = (
		<Icon size="medium" rotation={expanded ? "180" : "0"}>
			<IconChevron />
		</Icon>
	);

	return (
		<button
			aria-expanded={expanded}
			aria-controls={controls}
			onClick={(event) => {
				event.preventDefault();
				onClick(event);
			}}
			className={cn(
				scss.tableExpander,
				expanded && scss.expanded,
				scss[align],
				"fancy-BaseTable-Expander"
			)}
			data-observe-key={props["data-observe-key"]}
		>
			{align === "left" && chevy}
			{children}
			{align !== "left" && chevy}
		</button>
	);
}
